import React from "react";

const ThemedTextArea = React.forwardRef(
  ({ label, id, name, charCount, maxLength, errormessage, primaryColor, themeMode, optional, ...props }, ref) => {
    return (
      <div>
        <label
          htmlFor={name}
          className="block text-sm/6 font-medium text-themed-primary"
        >
          {label}
          {optional && (
            <span className="ml-1 font-normal text-themed-secondary">(optional)</span>
          )}
        </label>
        <div className="mt-2">
          <textarea
            id={id}
            name={name}
            ref={ref}
            rows={4}
            className={`themed-autofill block w-full rounded-md bg-themed-card px-3 py-1.5 text-base text-themed-primary shadow-sm ring-1 ring-inset ${
              errormessage ? "ring-2 ring-signal-red-500" : "ring-themed-border focus-themed"
            } placeholder:text-themed-secondary sm:text-sm/6`}
            {...props}
          />
        </div>
        {errormessage ? (
          <p className="mt-2 text-sm text-signal-red-500">{errormessage}</p>
        ) : null}
        <p
          className={`mt-2 text-sm ${
            charCount > maxLength ? "text-signal-red-500" : "text-themed-secondary"
          }`}
        >
          {charCount} / {maxLength} characters
        </p>
      </div>
    );
  }
);

ThemedTextArea.displayName = "ThemedTextArea";

export default ThemedTextArea;